var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
const BreakoutRoomDuration = ({ duration, created }) => {
    _react_refresh_temp_2();
    const [remaining, setRemaining] = useState('00:00');
    useEffect(() => {
        const start = Number(created) * 1000;
        let diff, minutes, seconds;
        const timer = () => {
            diff = Number(duration) * 60 - (((Date.now() - start) / 1000) | 0);
            minutes = (diff / 60) | 0;
            seconds = diff % 60 | 0;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            setRemaining(minutes + ':' + seconds);
            if (diff <= 0) {
                setRemaining('00:00');
            }
        };
        const interval = setInterval(() => {
            timer();
        }, 1000);
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [duration, created]);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "timer text-xs md:text-sm border border-solid border-primaryColor dark:border-white dark:text-white sm:py-[2px] px-3 rounded-br-lg -mt-[1px] -ml-[1px]", children: remaining }) }));
};
_react_refresh_temp_1 = BreakoutRoomDuration;
$RefreshReg$(_react_refresh_temp_1, "BreakoutRoomDuration");
_react_refresh_temp_2(BreakoutRoomDuration, "N6IxBQpOkQ1L9RZgCFPuo+nkehw=");
export default BreakoutRoomDuration;
